var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnhappyerror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/social/sentiment_dissatisfied_24pxerror") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.6041667,11.6666667 C21.3960438,11.6666667 20.4166667,12.6460438 20.4166667,13.8541667 C20.4166667,15.0622896 21.3960438,16.0416667 22.6041667,16.0416667 C23.8122896,16.0416667 24.7916667,15.0622896 24.7916667,13.8541667 C24.7916667,12.6460438 23.8122896,11.6666667 22.6041667,11.6666667 L22.6041667,11.6666667 Z M12.3958333,11.6666667 C11.1877104,11.6666667 10.2083333,12.6460438 10.2083333,13.8541667 C10.2083333,15.0622896 11.1877104,16.0416667 12.3958333,16.0416667 C13.6039562,16.0416667 14.5833333,15.0622896 14.5833333,13.8541667 C14.5833333,12.6460438 13.6039562,11.6666667 12.3958333,11.6666667 Z M17.5,20.4166667 C14.1020833,20.4166667 11.2,22.53125 10.0333333,25.5208333 L12.46875,25.5208333 C13.475,23.7854167 15.3416667,22.6041667 17.5,22.6041667 C19.6583333,22.6041667 21.5104167,23.7854167 22.53125,25.5208333 L24.9666667,25.5208333 C23.8,22.53125 20.8979167,20.4166667 17.5,20.4166667 L17.5,20.4166667 Z M17.4854167,2.91666667 C9.43541667,2.91666667 2.91666667,9.45 2.91666667,17.5 C2.91666667,25.55 9.43541667,32.0833333 17.4854167,32.0833333 C25.55,32.0833333 32.0833333,25.55 32.0833333,17.5 C32.0833333,9.45 25.55,2.91666667 17.4854167,2.91666667 Z M17.5,29.1666667 C11.0541667,29.1666667 5.83333333,23.9458333 5.83333333,17.5 C5.83333333,11.0541667 11.0541667,5.83333333 17.5,5.83333333 C23.9458333,5.83333333 29.1666667,11.0541667 29.1666667,17.5 C29.1666667,23.9458333 23.9458333,29.1666667 17.5,29.1666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "website-eng",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mainpage_systemerror",
    transform: "translate(-653.000000, -43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/sentiment_dissatisfied_24px",
    transform: "translate(651.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappyerror);
export default __webpack_public_path__ + "static/media/unhappyerror.078d7a5a8c19e772d16967b9f447b15f.svg";
export { ForwardRef as ReactComponent };